import React from "react";
import { useNavigate } from "react-router-dom";
import {
  UserSquare2,
  KeyRound,
  Wallet,
  ArrowDownToLine,
  Gift,
  Crown,
  Repeat,
  BadgeDollarSign,
  ReceiptText,
  MessageCircleMore,
  Users,
  RotateCcw,
  LogIn,
  LogOut,
  Gem,
} from "lucide-react";
import Announcement from "../../common/Announcement";
import BottomNav from "../../components/BottomNav/BottomNav";
import "./profile-interface.css";
import InnerHeader from "../../components/InnerHeader";
import useTranslate from "../../hooks/useTranslate";

export default function ProfileInterface({
  globalData,
  userData,
  onLogout,
}) {
  const navigate = useNavigate();
  const { t } = useTranslate();

  const menuItems = [
    { label: t("basicInformation"), icon: UserSquare2, path: "/basic-information" },
    { label: t("UpdateProfile"), icon: Users, path: "/personal" },
    { label: t("changePassword"), icon: KeyRound, path: "/change-password" },
    { label: t("deposit"), icon: Wallet, path: "/deposit" },
    { label: t("withdrawal"), icon: ArrowDownToLine, path: "/withdrawal" },
    { label: t("rebateReport"), icon: Gift, path: "/vip-rebate" },
    { label: t("promoFreeList"), icon: Gift, path: "/promo-free-list" },
    { label: t("vipBonusReport"), icon: Crown, path: "/vip-bonus" },
    // { label: t("transfer"), icon: Repeat, path: "/center-transfer" },
    { label: t("betReports"), icon: BadgeDollarSign, path: "/bet-reports" },
    { label: t("statements"), icon: ReceiptText, path: "/statements" },
    { label: t("notice"), icon: MessageCircleMore, path: "/notice" },
    { label: t("referralProgram"), icon: Users, path: "/referral-program" },
    { label: t("turnoverChecking"), icon: RotateCcw, path: "/turnover-checking" },
    { label: t("signIn"), icon: LogIn, path: "/daily-login-bonus" },
    {
      label: t("logout"),
      icon: LogOut,
      action: () => {
        localStorage.removeItem("token");
        localStorage.removeItem("remote_id");
        localStorage.removeItem("username");
        window.dispatchEvent(new Event("auth-changed"));
        onLogout?.();
        navigate("/home");
      },
    },
  ];

  const handleItemClick = (item) => {
    if (item.action) {
      item.action();
      return;
    }
    if (item.path) {
      navigate(item.path);
    }
  };

  return (
    <div className="accs-page">
      <InnerHeader title={t("memberProfile")} />

      <div className="accs-shell">
        <div className="accs-announcement-wrap">
          <Announcement globalData={globalData} />
        </div>

        <div className="accs-profile-card">
          <div className="accs-profile-left">
            <div className="accs-avatar-wrap">
              <img
                src="../../images/avtar-bg.png"
                alt={userData?.username}
                className="accs-avatar"
              />
            </div>

            <div className="accs-user-copy">
              <div className="accs-username">{userData?.username}</div>
              <div className="accs-phone">
                {t("tell")} : {userData?.phone}
              </div>
            </div>
          </div>

          <div className="accs-vip-badge">
            <span className="accs-vip-icon">
              <Gem size={20} strokeWidth={2.2} />
            </span>
            <span className="accs-vip-text">{userData?.vipLabel}</span>
          </div>
        </div>

        <div className="accs-menu-panel">
          {menuItems.map((item, index) => {
            const Icon = item.icon;

            return (
              <button
                key={`${item.label}-${index}`}
                type="button"
                className="accs-menu-item"
                onClick={() => handleItemClick(item)}
              >
                <span className="accs-menu-icon">
                  <Icon size={22} strokeWidth={2.2} />
                </span>
                <span className="accs-menu-label">{item.label}</span>
              </button>
            );
          })}
        </div>
      </div>

      <BottomNav />
    </div>
  );
}